module.exports = __webpack_public_path__ + "static/media/googleLogo.a81d4582.svg";